









import { Component, Vue } from 'vue-property-decorator';
import Leaflets from '@/components/Leaflets.vue';
import QRCode from '@/components/QRCode.vue';
import Navbar from '@/components/Navbar.vue';
import Contents from '@/components/Contents.vue';

@Component({
  components: {
    Leaflets,
    QRCode,
    Contents,
    Navbar
  }
})
export default class Split extends Vue {}
